import '~/lib/api/configure';

import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';

import { installTranslateDomCompat } from '~/lib/translate';

import { Router } from './Router';

installTranslateDomCompat();

const container = document.querySelector('.app');
const root = createRoot(container as Element);

root.render(<Router />);
